module.exports = __webpack_public_path__ + "img/dashboard-icon.4afb0e50.svg";